import { useRef, useState } from "react";

export default function useClickAndHold(callback, holdTime = 2000) {
	const timerRef = useRef(null);
	const [, setHolding] = useState(false);

	const start = (e) => {
		setHolding(true);
		timerRef.current = setTimeout(() => {
			callback(e);
			timerRef.current = null;
		}, holdTime);
	};

	const end = () => {
		setHolding(false);
		if (timerRef.current) {
			clearTimeout(timerRef.current);
			timerRef.current = null;
		}
	};

	return {
		onMouseDown: start,
		onMouseUp: end,
		onMouseLeave: end,
		onTouchStart: start,
		onTouchEnd: end,
	};
}
